import {
  ProgressProps as MantineProgressProps,
  Progress as MantineProgress,
  ProgressSectionProps as MantineProgressSectionProps,
  ProgressSection as MantineProgressSection,
  ProgressRootProps as MantineProgressRootProps,
  ProgressRoot as MantineProgressRoot,
  ProgressLabelProps as MantineProgressLabelProps,
  ProgressLabel as MantineProgressLabel,
} from '@mantine/core';

export type ProgressProps = MantineProgressProps;
export type ProgressSectionProps = MantineProgressSectionProps;
export type ProgressRootProps = MantineProgressRootProps;
export type ProgressLabelProps = MantineProgressLabelProps;

export const Progress = MantineProgress;
Progress.displayName = 'Progress';

export const ProgressSection = MantineProgressSection;
ProgressSection.displayName = 'ProgressSection';

export const ProgressRoot = MantineProgressRoot;
ProgressRoot.displayName = 'ProgressRoot';

export const ProgressLabel = MantineProgressLabel;
ProgressLabel.displayName = 'ProgressLabel';
